import * as React from 'react';
import { FC } from 'react';
import type { Locales, QuickSignupFormProps, Values, ChangeValues } from './types';

const Currency: FC<{
  values: Values;
  changeValues: ChangeValues;
  currencies: QuickSignupFormProps['currencies'];
  locales: Locales;
}> = ({ values, changeValues, currencies, locales }) => (
  <>
    <div className="currencies-title rs-text-align_center">{locales.currency.label}</div>
    <div className="input player_currency">
      {currencies.map(([c, symbol]) => (
        <div className="radio" key={c}>
          <input
            type="radio"
            value={c}
            onChange={(e) => changeValues({ currency: e.target.value })}
            checked={c === values.currency}
            name="player[currency]"
            id={`player_currency_${c}`}
          />
          <label htmlFor={`player_currency_${c}`}>
            <span>
              <span className="symbol">{symbol}</span>
              <span className="name">{c}</span>
            </span>
          </label>
        </div>
      ))}
      <span className="hint">{locales.currency.hint}</span>
    </div>
  </>
);

export default Currency;
